export const parametersCsvFields = [
  "orderId",
  "returnRequestId",
  "orderName",
  "orderTags",
  "returnCode",
  "createdAt",
  "orderedAt",
  "updatedAt",
  "shippedAt",
  "shippingAt",
  "treatedLogisticianAt",
  "treatedMerchantAt",
  "pickupTiming",
  "pickupTimingEnd",
  "internalComments",
  "comment",
  "customerImages",
  "status",
] as const;

export const shippingCsvFields = [
  "shippingAddress1",
  "shippingAddress2",
  "shippingCity",
  "shippingZip",
  "shippingCountry",
  "shippingCountryCode",
  "shippingInfoCarrier",
  "shippingInfoTrackingCode",
  "customerId",
  "customerEmail",
  "customerFirstName",
  "customerLastName",
  "customerPhone",
  "lang",
] as const;

export const dataTreatmentCsvFields = [
  "logisticianValidated",
  "logisticianRejected",
  "logisticianReasonRejected",
  "merchantValidated",
  "merchantRejected",
  "merchantReasonRejected",
  "variantId",
  "quantity",
  "newVariantId",
  "newVariantBarcode",
  "locationId",
  "newOrderName",
] as const;

export const resultCsvFields = [
  "refunded",
  "discounted",
  "initialShippingRefund",
  "returnShippingPaid",
  "rebuyAmount",
  "lineItemId",
  "sku",
  "title",
  "price",
  "originalPrice",
  "reason",
  "reasonExternalId",
  "productId",
  "quantityBought",
  "variantTitle",
  "variantBarcode",
  "resolution",
  "metafieldsVariant",
  "metafieldsProduct",
  "metafieldsOrder",
  "customAttributesRR",
] as const;
